// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5533e99","389":"65760ce4","455":"10703399","508":"f2613355","977":"2a7ec8ae"}[chunkId] + ".chunk.js";
};